import React from "react";
import { Route, Routes } from "react-router-dom";
import SalesDashboard from "./sales";
import SalesProducts from "./sales-products";

const Reports = () => {
  return (
    <Routes>
      <Route path="sales" element={<SalesDashboard />} />
      <Route path="sales/products" element={<SalesProducts />} />
    </Routes>
  );
};

export default Reports;
